module.exports = lottie;


//////////////////
// WEBPACK FOOTER
// external "lottie"
// module id = external "lottie"
// module chunks = core login